import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.LabelsWordCloudSectionView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'words-cloud-section-view'
  name: 'words-cloud-section-view'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]

  initialize: (@options = {}) ->
    @colors = @options.colors

  render: ->
    @specific_settings.benchmark = true
    @$el.html(@template(self: this))
    @bindChartsReady(1)
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    page = @getTemplateOptions().page
    @setBenchmarkSettingsIfNecessary(query)
    $.post(@options.chartApi.label_ancestors + @getTemplateOptions().network, _.extend(query, {page: page}), (response) =>
      @_process_clouds(response)
    )

  _process_clouds: (response) ->
    clouds = []    
    cloudOptions = {
      date_from_ISO: @options.fromISO.toISOString(),
      date_to_ISO: @options.toISO.toISOString(),
      account_id: @getURLParams()["account_id"]
    }
    
    clouds.push(new Monitoring.Reports.Executive.WordsCloudView(_.extend({name: "Todos los labels"}, cloudOptions)))
    for label, ancestors of response  
      clouds.push(new Monitoring.Reports.Executive.WordsCloudView(_.extend({name: label, ancestors: ancestors}, cloudOptions)))

    for cloud in clouds
      cloud.bind('rendered', @_sectionRendered)
      cloud.render()
      @el.children[0].children[1].children[0].appendChild(cloud.el)

  _sectionRendered: =>
    @pending -= 1
    @trigger('rendered') if @pending == 0

  #from https://stelfox.net/blog/2013/12/access-get-parameters-with-coffeescript/
  getURLParams: ->
    query = window.location.search.substring(1)
    raw_vars = query.split("&")
    params = {}
    for v in raw_vars
      [key, val] = v.split("=")
      params[key] = decodeURIComponent(val)
    return params
